/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Page from 'src/components/Page';
import ReportsGraph from './components/ReportsGraph';
// import IssuesTrendChartMenu from './components/IssuesTrendChartMenu';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }
}));
export default function ReportsModule() {
  const classes = useStyles();
  return (
    <Page className={classes.root} title="Reports">
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <ReportsGraph />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
